@if (isAvailable()) {

<button
  type="button"
  (click)="openReleaseDocumentation()"
  [attr.aria-label]="'Open release ' + releaseNumber() + ' documentation'"
  title="Open release documentation"
  class="cursor-pointer border-none bg-none p-0 text-white transition-colors hover:text-blue-500"
>
  {{ releaseNumber() }}
</button>
} @else {
<span>{{ releaseNumber() }}</span>
}
